import axios from "api/axios"
import { APIResponse, ConfigWithURLParams } from "api/types"
import { formatErrorResponse, formatSuccessResponse } from "api/utils"

import { IQAUpdateReviewPayload, IQAUpdateReviewResponse } from "./types"
import { urls } from "./urls"

export default {
  updateReview: async ({
    urlParams,
    data,
  }: ConfigWithURLParams<"reviewUuid"> & {
    data: IQAUpdateReviewPayload
  }): Promise<APIResponse<IQAUpdateReviewResponse>> => {
    try {
      const res = await axios.patch(
        urls.iqa.updateReview(urlParams.reviewUuid),
        data
      )
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
}
